import { defaultTransactionFieldsValues, EventDispatch } from './constraints';
import { apiCielo, CIELO_ENVIRONMENT } from "../../services/api";

var env = CIELO_ENVIRONMENT;
const isLocalhost = window.location.hostname.includes("localhost");
const orderDataKey = "@pagtel-recharge:order-data";
export const rechargeDataKey = "@pagtel-recharge:recharge-data";

function createCieloDispatcher(eventName, data = null) {
  BP.Log(`ON ${eventName.replace("_", " ").toUpperCase()}`, data);

  const eventToDispatch = new CustomEvent(eventName, { detail: data });
  document.dispatchEvent(eventToDispatch);
}

function bpmpi_config() {
  return {
    onReady: function () {
      // Evento indicando quando a inicialização do script terminou.
      createCieloDispatcher(EventDispatch.READY);
    },
    onSuccess: async function (e) {
      // Cartão elegível para autenticação, e portador autenticou com sucesso.
      createCieloDispatcher(EventDispatch.SUCCESS, {
        ...e,
        Eci: Number(e.Eci)
      });
    },
    onFailure: function (e) {
      // Cartão elegível para autenticação, porém o portador finalizou com falha.
      createCieloDispatcher(EventDispatch.FAILURE, e);
    },
    onUnenrolled: function (e) {
      // Cartão não elegível para autenticação (não autenticável).
      createCieloDispatcher(EventDispatch.UNENROLLED, e);
    },
    onDisabled: function () {
      // Loja não requer autenticação do portador (classe "bpmpi_auth" false -> autenticação desabilitada).
      createCieloDispatcher(EventDispatch.DISABLED);
    },
    onError: function (e) {
      // Erro no processo de autenticação.
      createCieloDispatcher(EventDispatch.ERROR, e);
    },
    onUnsupportedBrand: function (e) {
      // Bandeira não suportada para autenticação.
      createCieloDispatcher(EventDispatch.UNSUPPORTED_BRAND, e);
    },
    Environment: env ? env : "SDB",
    Debug: isLocalhost,
  };
}

export function bpmpi_authenticate(token, data) {
  BP.Mpi.authenticate(token, data);
}

export function bpmpi_load(orderDetails, token) {
  return BP.Mpi.load(orderDetails, token);
}

export function bmpi_cardinal_init(token, referenceId) {
  BP.Cardinal.init(token, referenceId, 'dsadas');
}

var BP = (function () {
  function getBPMPIConfig() {
    return "undefined" != typeof bpmpi_config
      ? bpmpi_config()
      : {
          Debug: isLocalhost,
          Environment: env,
        };
  }

  function getSongbirdURL() {
    if(env === "PRD") return "https://songbird.cardinalcommerce.com/edge/v1/songbird.js"
    return "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js";
  }

  async function loadScript(scriptUrl, callback = () => {}) {
    var head = document.getElementsByTagName("head")[0];
    var script = document.createElement("script");

    script.type = "text/javascript";
    script.src = scriptUrl;
    script.onreadystatechange = callback;
    script.onload = callback;

    head.appendChild(script);
  }

  function getDebugMode() {
    return BPMPIConfig.Debug !== undefined ? BPMPIConfig.Debug : false;
  }

  function debugLog(...rest) {
    getDebugMode() && console.log.apply(null, rest);
  }

  function getLoggingMode() {
    return getDebugMode() ? "verbose" : "off";
  }

  function initializeCardinal(token, referenceId, cieloToken) {
    debugLog("[MPI]", "Initializing...");
    debugLog("[MPI]", "Token =", token);
    debugLog("[MPI]", "CieloToken =", cieloToken);
    debugLog("[MPI]", "ReferenceId =", referenceId);
    Cardinal.configure({ // eslint-disable-line no-undef
      timeout: "8000",
      maxRequestRetries: "10",
      logging: {
        level: getLoggingMode(),
      },
    });
    Cardinal.setup("init", { // eslint-disable-line no-undef
      jwt: token,
    });
    Cardinal.on("payments.setupComplete", function (e) { // eslint-disable-line no-undef
      debugLog("[MPI]", "Setup complete.");
      debugLog("[MPI]", "SetupCompleteData =", e);
      notifyEvent("onReady");
    });
    Cardinal.on("payments.validated", function (e) { // eslint-disable-line no-undef
      switch (
        (debugLog("[MPI]", "Payment validated."),
        debugLog("[MPI]", "ActionCode =", e.ActionCode),
        debugLog("[MPI]", "Data =", e),
        e.ActionCode)
      ) {
        case "SUCCESS":
        case "NOACTION":
        case "FAILURE":
          validate3DS(e.Payment.ProcessorTransactionId, cieloToken);
          break;
        case "ERROR":
          errorData.Number = e.ErrorNumber;
          errorData.Description = e.ErrorDescription;
          e.Payment && e.Payment.ProcessorTransactionId
            ? validate3DS(e.Payment.ProcessorTransactionId, cieloToken)
            : notifyEvent("onError", {
                Xid: null,
                Eci: null,
                ReturnCode: errorData.HasError()
                  ? errorData.Number
                  : "MPI901",
                ReturnMessage: errorData.HasError()
                  ? errorData.Description
                  : "Unexpected error",
                ReferenceId: null,
              });
          break;
        default:
          errorData.Number = e.ErrorNumber;
          errorData.Description = e.ErrorDescription;
          "Success" === e.ErrorDescription &&
          e.Payment &&
          e.Payment.ProcessorTransactionId
            ? validate3DS(e.Payment.ProcessorTransactionId, cieloToken)
            : notifyEvent("onError", {
                Xid: null,
                Eci: null,
                ReturnCode: errorData.HasError()
                  ? errorData.Number
                  : "MPI902",
                ReturnMessage: errorData.HasError()
                  ? errorData.Description
                  : "Unexpected authentication response",
                ReferenceId: null,
              });
      }
    });
  }

  function sendJsonRequest(endpoint, requestData, responseHandler, token) {
    return apiCielo.post(endpoint, requestData, {
      headers: {
        authorization: `Bearer ${token}`
      },
    }).then((response) => {
      responseHandler(response.data, this);
    }).catch((error) => {
      notifyEvent("onError", {
        Xid: null,
        Eci: null,
        ReturnCode: "MPI900",
        ReturnMessage: "An error has occurred (" + error.response.status + ")",
        ReferenceId: null,
      });
    });
  }

  function loadCardinalResourcesAndInit3DS(orderDetails, token) {
    debugLog("[MPI]", "Debug =", getDebugMode());
    debugLog("[MPI]", "Enviroment =", env);

    debugLog("[MPI]", "Loading resources...");

    loadScript(getSongbirdURL(), () => {
      debugLog("[MPI]", "Cardinal script loaded.");

      sendJsonRequest("/v2/3ds/init", orderDetails, function (e) {
        initializeCardinal(e.Token, e.ReferenceId, token);
        return e;
      }, token);
    });
  }

  function performAuthentication(token, orderData) {
    debugLog("[MPI]", "Enrolling...");
    localStorage.setItem(orderDataKey, JSON.stringify(orderData));
    Cardinal.trigger( // eslint-disable-line no-undef
      "accountNumber.update",
      orderData.cardnumber
    );
    sendJsonRequest(
      "/v2/3ds/enroll",
      orderData,
      function (e) {
        debugLog("[MPI]", "Enrollment result =", e);
        e.Version && (Version = e.Version[0]);
        var r = e.Authentication;
        switch (e.Status) {
          case "ENROLLED":
            handleChallenge(e);
            break;
          case "VALIDATION_NEEDED":
            validate3DS(e.AuthenticationTransactionId, token);
            break;
          case "AUTHENTICATION_CHECK_NEEDED":
            handleAuthenticationResult(r);
            break;
          case "NOT_ENROLLED":
            notifyEvent("onUnenrolled", {
              Xid: r.Xid,
              Eci: r.Eci,
              Version,
              ReferenceId: r.DirectoryServerTransactionId,
            });
            break;
          case "FAILED":
            notifyEvent("onFailure", {
              Xid: r.Xid,
              Eci: r.Eci || r.EciRaw,
              Version,
              ReferenceId: r.DirectoryServerTransactionId,
            });
            break;
          case "UNSUPPORTED_BRAND":
            notifyEvent("onUnsupportedBrand", {
              Xid: null,
              Eci: null,
              ReturnCode: e.ReturnCode,
              ReturnMessage: e.ReturnMessage,
              ReferenceId: null,
            });
            break;
          default:
            notifyEvent("onError", {
              Xid: null,
              Eci: null,
              ReturnCode: e.ReturnCode,
              ReturnMessage: e.ReturnMessage,
              ReferenceId: null,
            });
        }
      },
      token
    );
  }

  function buildOrderObject(transactionId) {
    debugLog("[MPI] Building order object...");

    const orderData = JSON.parse(localStorage.getItem(orderDataKey));
    const extractedValues = {
      ...defaultTransactionFieldsValues,
      ...orderData
    };

    var orderObject = {
      OrderDetails: {
        TransactionId: transactionId,
        OrderNumber: extractedValues.ordernumber,
        CurrencyCode: extractedValues.currency,
        OrderChannel: extractedValues.transactionmode,
      },
      Consumer: {
        Account: {
          AccountNumber: extractedValues.cardnumber,
          ExpirationMonth: extractedValues.cardexpirationmonth,
          ExpirationYear: extractedValues.cardexpirationyear,
        },
        Email1: extractedValues.shiptoemail,
        Email2: extractedValues.billtoemail,
        ShippingAddress: {
          FullName: null,
          Address1: null,
          Address2: null,
          City: null,
          State: null,
          PostalCode: null,
          CountryCode: null,
          Phone1: null,
        },
        BillingAddress: {
          FullName: extractedValues.billtocontactname,
          Address1: extractedValues.billtostreet1,
          Address2: extractedValues.billtostreet2,
          City: extractedValues.billtocity,
          State: extractedValues.billtostate.toUpperCase(),
          PostalCode: extractedValues.billtozipcode,
          CountryCode: extractedValues.billtocountry,
          Phone1: extractedValues.billtophonenumber,
        },
      },
      Cart: [],
    };

    var billingAddress = orderObject.Consumer.BillingAddress;

    orderObject.Consumer.ShippingAddress.FullName = billingAddress.FullName;
    orderObject.Consumer.ShippingAddress.Address1 = billingAddress.Address1;
    orderObject.Consumer.ShippingAddress.Address2 = billingAddress.Address2;
    orderObject.Consumer.ShippingAddress.City = billingAddress.City;
    orderObject.Consumer.ShippingAddress.State = billingAddress.State;
    orderObject.Consumer.ShippingAddress.PostalCode = billingAddress.PostalCode;
    orderObject.Consumer.ShippingAddress.Phone1 = billingAddress.Phone1;
    orderObject.Consumer.ShippingAddress.CountryCode = billingAddress.CountryCode;

    debugLog("[MPI] Order object =", orderObject);
    return orderObject;
  }

  function handleChallenge(e) {
    const orderData = JSON.parse(localStorage.getItem(orderDataKey));
    var suppressChallenge = orderData.authsuppresschallenge;
    debugLog("[MPI] Suppression enabled = " + suppressChallenge);

    if (suppressChallenge) {
      debugLog("[MPI]", "Challenge supressed...");
      const suppressionResponse = {
        Xid: null,
        Eci: null,
        ReturnCode: "MPI601",
        ReturnMessage: "Challenge suppressed",
        ReferenceId: null,
      };
      notifyEvent("onChallengeSuppression", suppressionResponse);
      return;
    }

    debugLog("[MPI]", "Showing challenge...");
    var continueObject = {
      AcsUrl: e.AcsUrl,
      Payload: e.Pareq,
      TransactionId: e.AuthenticationTransactionId,
    };
    const orderObject = buildOrderObject(e.AuthenticationTransactionId);

    debugLog("[MPI] Continue object =", continueObject);
    Cardinal.continue("cca", continueObject, orderObject); // eslint-disable-line no-undef
  }

  function handleAuthenticationResult(result) {
    switch (
      (debugLog("[MPI]", "Authentication result =", result), result.Status)
    ) {
      case "AUTHENTICATED":
        notifyEvent("onSuccess", {
          Cavv: result.Cavv,
          Xid: result.Xid,
          Eci: result.Eci,
          Version: result.Version[0],
          ReferenceId: result.DirectoryServerTransactionId,
        });
        break;
      case "UNAVAILABLE":
        notifyEvent("onUnenrolled", {
          Xid: result.Xid,
          Eci: result.Eci,
          Version: result.Version[0],
          ReferenceId: result.DirectoryServerTransactionId,
        });
        break;
      case "FAILED":
        notifyEvent("onFailure", {
          Xid: result.Xid,
          Eci: result.Eci || result.EciRaw,
          Version: result.Version[0],
          ReferenceId: result.DirectoryServerTransactionId,
        });
        break;
      case "ERROR_OCCURRED":
        notifyEvent("onError", {
          Xid: result.Xid,
          Eci: result.Eci || result.EciRaw,
          ReturnCode: result.ReturnCode,
          ReturnMessage: result.ReturnMessage,
          ReferenceId: result.DirectoryServerTransactionId,
        });
        break;
      default:
        notifyEvent("onError", {
          Xid: result.Xid,
          Eci: result.Eci || result.EciRaw,
          ReturnCode: errorData.HasError()
            ? errorData.Number
            : result.ReturnCode,
          ReturnMessage: errorData.HasError()
            ? errorData.Description
            : result.ReturnMessage,
          ReferenceId: result.DirectoryServerTransactionId,
        });
    }
  }

  function validate3DS(transactionId, token) {
    var data = JSON.parse(localStorage.getItem(orderDataKey));
    data.transactionId = transactionId;

    debugLog("[MPI]", "Validating...");
    sendJsonRequest("/v2/3ds/validate", data, (result) => handleAuthenticationResult(result), token);
    localStorage.removeItem(orderDataKey);
  }

  function isBPMPIConfigFunctionDefined(e) {
    return "function" == typeof BPMPIConfig[e];
  }

  function notifyEvent(type, data) {
    debugLog("[MPI]", "Notifying...");
    debugLog("[MPI]", "Event type =", type);
    debugLog("[MPI]", "Event data =", data || "None");
    isBPMPIConfigFunctionDefined(type) && BPMPIConfig[type](data);
  }

  var BPMPIConfig = getBPMPIConfig(),
    Version = null,
    errorData = {
      Number: null,
      Description: null,
      HasError: () => null !== this.Number
    };

  return {
    Mpi: {
      load: loadCardinalResourcesAndInit3DS,
      authenticate: performAuthentication
    },
    Cardinal: {
      init: initializeCardinal
    },
    Log: debugLog
  };
})();